<template>
  <div class="field-input-text">
    <div class="input-group">
      <field-icon :fieldData="fieldData"></field-icon>

      <input
        :type="inputType"
        :ref="fieldData.field_name"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-model="fieldData.field_value"
        v-validate="fieldData.field_validation_rules"
        autocomplete="new-password"
        v-bind:class="{'form-control': true,
          'error': errors.has(fieldData.field_name) }">
    </div>
  </div>
</template>

<script>
import FieldIcon from '../presentational/FieldIcon';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType'],
  $_veeValidate: {
    events: 'input',
    rejectsFalse: false,
  },
  components: { FieldIcon },
  mounted() {
    this.$validator.validate(this.fieldData.field_name); // TODO: Use 'immediate' on the directive
  },
  created() {
    this.$validator.fastExit = false; // TODO: Use 'continues' on the directive
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputPassword.vue?bd617822